import { render, staticRenderFns } from "./HelpSectionsList.vue?vue&type=template&id=63458326&"
import script from "./HelpSectionsList.vue?vue&type=script&lang=js&"
export * from "./HelpSectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports